import { render, staticRenderFns } from "./InOut.vue?vue&type=template&id=06069672&scoped=true"
import script from "./InOut.vue?vue&type=script&lang=js"
export * from "./InOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06069672",
  null
  
)

export default component.exports